import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, Card } from '@/components/Primitives';

const AuditLog = () => {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get('/audit-logs').then((r) => setItems(r.data));
    }, []);
    return (
        <>
            <PageHeader
                eyebrow="Security"
                title="Audit Log"
                description="Záznam všech akcí provedených v systému – pro účely compliance a forenzního auditu."
            />
            <Card>
                {items.length === 0 ? (
                    <div className="py-8 text-center text-sm font-mono" style={{ color: 'var(--text-secondary)' }}>
                        Zatím žádné záznamy.
                    </div>
                ) : (
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-[10px] uppercase tracking-[0.1em]"
                                style={{ color: 'var(--text-secondary)' }}>
                                <th className="text-left py-2">Čas</th>
                                <th className="text-left">Aktér</th>
                                <th className="text-left">Akce</th>
                                <th className="text-left">Entita</th>
                                <th className="text-left">ID</th>
                                <th className="text-left">Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((a) => (
                                <tr key={a.id} className="border-t"
                                    style={{ borderColor: 'var(--border-default)' }}>
                                    <td className="py-2 font-mono text-[11px]">{(a.created_at || '').replace('T', ' ').slice(0, 19)}</td>
                                    <td className="font-mono text-xs">{a.actor_email || '—'}</td>
                                    <td className="font-mono text-xs">{a.action}</td>
                                    <td className="font-mono text-xs">{a.entity}</td>
                                    <td className="font-mono text-[11px]">{a.entity_id || '—'}</td>
                                    <td className="font-mono text-[11px]" style={{ color: 'var(--text-secondary)' }}>
                                        {a.details ? JSON.stringify(a.details).slice(0, 80) : ''}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </Card>
        </>
    );
};

export default AuditLog;
